module.exports = __webpack_public_path__ + "static/media/font_medium.a006b1c9.woff2";